import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The theme names font sizes by pixel (text-14). tailwind-merge does not know
 * them and files them as colours, so a size next to text-grey-120 was dropped.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        '9',
        '12',
        '14',
        '16',
        '18',
        '20',
        '22',
        '24',
        '26',
        '34',
        '42',
        '60',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
